import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import { selectAuth } from "../../components/auth/auth.selector";
import { fetchWhatsNewData } from "../../redux/website-reducers/websiteSlice";
import AllWhatsNew from "../../components/website-contents/whats-new/AllWhatsNew";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import SearchNButtons from "../../components/common-components/SearchNButtons";

const WhatsNew = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const iniModValues = {
    isModOpen: false,
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  function onCloseModalvalues() {
    setModValues(iniModValues);
  }

  const [page, setPage] = useState(0); // 0-based for the table; backend gets page + 1

  function getWhatsNew(p = page) {
    dispatch(
      fetchWhatsNewData({
        token: userInfoData?.token,
        page: p + 1,
      })
    );
  }

  useEffect(() => {
    getWhatsNew(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <HelmetWrapper title="WTF: What's New">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <MealsStructure text={"What's New"} />
          </Col>
        </Row>

        <br />

        <Row>
          <Col>
            <SearchNButtons
              pageName={"whats-new"}
              btnText={"+ Add new"}
              onClickAdd={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <AllWhatsNew
              callFunction={() => {
                getWhatsNew(page);
              }}
              userInfoData={userInfoData}
              modValues={modValues}
              setModValues={setModValues}
              onCloseModalvalues={onCloseModalvalues}
              page={page}
              setPage={setPage}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default WhatsNew;
